import {
  Component,
  ElementRef,
  HostListener,
  input,
  OnDestroy,
  OnInit,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ITown } from 'src/app/models';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { StorageService } from 'src/app/services';
import { images } from 'src/images';

@Component({
  selector: 'app-change-area',
  templateUrl: './change-area.component.html',
  styleUrl: './change-area.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChangeAreaComponent implements OnInit, OnDestroy {
  readonly fromLocation = input<string>('areas');
  readonly towns = input<ITown[]>([]);
  readonly styles = input<string>('');
  readonly showItemEdit = input<boolean>(false);
  readonly showCreate = input<boolean>(false);
  readonly changeEventEmitter = output<any>();
  readonly editTownEventEmitter = output<ITown>();
  readonly createTownEventEmitter = output<void>();
  public images = images;
  public selectedTowns: unknown[] = [];
  public showTowns = false;

  private queryParamsSub?: Subscription;

  @HostListener('document:click', ['$event'])
  clickOutsideComponent(event: any) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      if (this.showTowns) {
        this.showTowns = false;
      }
    }
  }

  constructor(
    public literalService: LiteralService,
    private activatedRoute: ActivatedRoute,
    private eRef: ElementRef,
    private storageService: StorageService,
  ) {}

  async ngOnInit() {
    switch (this.fromLocation()) {
      case 'trips':
      case 'services':
        // URL is canonical; subscribe so back/forward updates the dropdown.
        this.queryParamsSub = this.activatedRoute.queryParamMap.subscribe(
          (params) => {
            this.applyUrlSelection(params.get('towns'));
          },
        );
        break;

      default:
        break;
    }
  }

  ngOnDestroy(): void {
    this.queryParamsSub?.unsubscribe();
  }

  private applyUrlSelection(urlTownsRaw: string | null): void {
    if (!urlTownsRaw) {
      this.selectedTowns = [];
      return;
    }
    const ids = urlTownsRaw
      .split(',')
      .map(Number)
      .filter((n) => !isNaN(n));
    const known = this.towns();
    this.selectedTowns = ids
      .map((id) => known.find((t) => t.id === id) ?? ({ id } as ITown))
      .filter((t) => t != null);
  }

  get headerLabel(): string {
    return this.literalService.get('trips.area', true);
  }

  get headerSuffix(): string {
    if (
      this.selectedTowns.length === 0 ||
      this.selectedTowns.length === this.towns().length
    ) {
      return `(${this.literalService.get('allAreas')})`;
    }

    return `(${this.selectedTowns.length})`;
  }

  onMultiSelectChange(event: any): void {
    this.changeEventEmitter.emit(event);
    setTimeout(() => {
      const data = JSON.stringify(this.selectedTowns);
      if (this.fromLocation() === 'services') {
        this.storageService.setServicesAreas(data);
      } else {
        this.storageService.setArea(data);
      }
    });
  }

  handleTowns() {
    this.showTowns = !this.showTowns;
  }

  openTowns() {
    this.showTowns = true;
  }

  closeTowns() {
    this.showTowns = false;
  }
}
